import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getQueuesResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmQueuesAddonRoute } from '@jira/router-routes__servicedesk-queues-routes/src/csmQueuesAddonRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { queuesAddonViewEntryPoint } from '@jira/spa-apps__servicedesk-queues-addon-view/src/queuesAddonViewEntryPoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const csmQueuesAddonPageEntryPoint = createPageEntryPoint({
	main: queuesAddonViewEntryPoint,
});

export const csmQueuesAddonRouteEntry: Route = createEntry(csmQueuesAddonRoute, () => ({
	group: 'customer-service',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdCsmApp,
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getQueuesResources(),
		getConsolidationStateResource(),
	],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmQueuesAddonPageEntryPoint
			: notFoundPageEntrypoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
